import { Children, type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';

import { UL } from '@expo/html-elements';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsNutritionEntriesList = (props: Props) => {
  const { children } = props;

  const hasChildren = Children.toArray(children).some(Boolean);

  if (!hasChildren) {
    return null;
  }

  return <UL style={styles.container}>{children}</UL>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    gap: 10,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren;
